module.exports = __webpack_public_path__ + "img/down-gx1.fb503710.jpg";